// extracted by mini-css-extract-plugin
export default {"Statistics":"style_Statistics__UYpeU","Statistics__container":"style_Statistics__container__KEUac","title":"style_title__RdVrS","desc":"style_desc__oNZax"};